export default "__VITE_ASSET__DdswpXMZ__"